import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { DatePicker, ActionSheet, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less';

const PageModel = props => {
	const [List, setList] = useState([]);
	const getList = async () => {
		const result = await Request.get({
			url: '/equipmentunkeep/list'
		});
		if (!result) return;
		setList(result.data);
	};
	useEffect(() => {
		//获取设备列表
		getList()
	}, [123]);

	return (
		<Page {...{ page: 'upkeep', showFooter: true, title: '设备保养' }} {...props}>
			<section className="upkeep-container" style={{ minHeight: window.innerHeight - 50 }}>
				<div className='upkeep-div'>
					{
						List.length > 0 && List.map((item, index) => {
							return (
								<div key={index} className='upkeep-header' onClick={() => { props.history.push('/upkeepdetail/' + item.id) }}>
									{
										item.equipmentType == 1 && <img src={require('../../common/images/yy.png')} alt='home-icon' />
										||
										item.equipmentType == 2 && <img src={require('../../common/images/fj.png')} alt='home-icon' />
									}
									<div className='upkeep-header-title'>{item.equipmentType == 1 ? '油烟净化器' : '风机'}</div>
								</div>
							)
						})
					}
					{
						List.length == 0 && <div className='upkeep-msg'>暂无绑定店铺和设备</div>
					}
				</div>
			</section>
		</Page>
	);
};

export default PageModel;
